import { template as template_68df39add9384f62ba649039323e1d0b } from "@ember/template-compiler";
import { componentFor } from 'client-portal/utils/clinicianSearch/facets/manifest';
import Component from '@glimmer/component';
export default class RequestClinicianSearchFacetFilterContent extends Component {
    get facetComponent() {
        return componentFor(this.args.facetName);
    }
    static{
        template_68df39add9384f62ba649039323e1d0b(`
    {{#if this.facetComponent}}
      <this.facetComponent />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
